// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Instagram from '../_raw/ui/instagram.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Instagram);
